module.exports = __webpack_public_path__ + "static/media/0-3.0ca21d38.svg";